export enum Sex {
    Male = 477,
    Female = 478,
    Undefined = 548,
}

export enum AppointmentStatus {
    SlotEdited = 2128,
    PreBooked = 2129,
    Booked = 2130,
    Fake = 2131,
    Confirmed = 2132,
}
